// FNP-535: read-only reconciliation history. Two queries, both backed by the FNP-521
// read-model on billing-api. listReconciliationReports is Query-backed on the
// channel-runStartedAt-index (per-channel, newest-first), never a Scan — and channel
// is REQUIRED (the GSI partition key).

export const listReconciliationReports = `
   query listReconciliationReports($channel: BillingChannel!, $limit: Int, $nextToken: String) {
       listReconciliationReports(channel: $channel, limit: $limit, nextToken: $nextToken) {
           items {
              id
              channel
              runDate
              runStartedAt
              runCompletedAt
              oursButNotTheirsCount
              theirsButNotOursCount
              quantityMismatchCount
              discrepancyDetailsS3Uri
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const getReconciliationReport = `
   query getReconciliationReport($id: ID!) {
       getReconciliationReport(id: $id) {
         id
         channel
         runDate
         runStartedAt
         runCompletedAt
         oursButNotTheirsCount
         theirsButNotOursCount
         quantityMismatchCount
         discrepancyDetails
         discrepancyDetailsS3Uri
         recordType
         created
         updated
       }
}`;
